module.exports = __webpack_public_path__ + "img/sibi_3kl.1f40f3e8.jpg";